import { useEffect, useState } from "react";

function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M8.5 12.3l2.2 2.2 4.8-5.1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AlertIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 7.8v5.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="16.6" r="1" fill="currentColor" />
    </svg>
  );
}

function InfoIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 10.5v5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="7.8" r="1" fill="currentColor" />
    </svg>
  );
}

function CloseIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M8 8l8 8M16 8l-8 8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function tone(type = "info") {
  if (type === "success") {
    return {
      shell: "border-emerald-200 bg-emerald-50/95 text-emerald-900",
      icon: "text-emerald-600",
      Icon: CheckIcon,
    };
  }
  if (type === "error") {
    return {
      shell: "border-rose-200 bg-rose-50/95 text-rose-900",
      icon: "text-rose-600",
      Icon: AlertIcon,
    };
  }
  return {
    shell: "border-[#e7d1ad] bg-white/95 text-[#3e2a18]",
    icon: "text-[#a4762f]",
    Icon: InfoIcon,
  };
}

export default function ToastHost() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const onToast = (event) => {
      const detail = event.detail || {};
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const next = {
        id,
        message: detail.message || "",
        type: detail.type || "info",
        duration: detail.duration || 3200,
      };

      setToasts((curr) => [...curr, next]);
      window.setTimeout(() => {
        setToasts((curr) => curr.filter((toast) => toast.id !== id));
      }, next.duration);
    };

    window.addEventListener("app:toast", onToast);
    return () => window.removeEventListener("app:toast", onToast);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="pointer-events-none fixed right-4 top-20 z-[120] flex w-[min(92vw,420px)] flex-col gap-3">
      {toasts.map((toast) => {
        const styles = tone(toast.type);
        const Icon = styles.Icon;
        return (
          <div
            key={toast.id}
            className={`pointer-events-auto overflow-hidden rounded-2xl border shadow-[0_24px_60px_-30px_rgba(47,28,15,0.55)] backdrop-blur ${styles.shell}`}
          >
            <div className="flex items-start gap-3 px-4 py-3">
              <div className={`mt-0.5 ${styles.icon}`}>
                <Icon size={20} />
              </div>
              <div className="min-w-0 flex-1 text-sm font-medium">
                {toast.message}
              </div>
              <button
                type="button"
                onClick={() =>
                  setToasts((curr) =>
                    curr.filter((item) => item.id !== toast.id)
                  )
                }
                className="rounded-lg p-1 text-[#8a7257] hover:bg-black/5"
                aria-label="Dismiss toast"
              >
                <CloseIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
